import { GoalStatus } from "@/ts/common-types";
import { GOAL_STATUS_CONFIG } from "@/ts/constants";
import { ICellRendererParams } from "ag-grid-community";

const GoalStatusCellRenderer = (params: ICellRendererParams) => {
    const goalAchievedStatus: GoalStatus = params.data.is_achieved
        ? GoalStatus.ACHIEVED
        : GoalStatus.UNACHIEVED;

    return (
        <>
            {params.node.rowPinned ? null : (
                <span
                    style={{
                        fontWeight: "bold",
                        color: GOAL_STATUS_CONFIG[goalAchievedStatus].color,
                    }}
                >
                    {`${GOAL_STATUS_CONFIG[goalAchievedStatus].text}`}
                </span>
            )}
        </>
    );
};

export default GoalStatusCellRenderer;
